<template>
  <div>
    <div class="row pt-3 l-m-b-20">
      <div class="col-9">
        <h1>Follow up templates</h1>
      </div>
      <div class="col-3 text-right">
        <button class="btn btn-primary" type="button" @click="showModal = true">
          ADD TEMPLATE
        </button>
      </div>
    </div>
    <template v-if="!templates">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <table class="table m-table table-hover l-m-t-20">
        <thead class="m-table__heading">
          <tr>
            <th class="m-table__id">ID</th>
            <th>Name</th>
            <th>Subject</th>
            <th>Body</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="template in templates" @click="editTemplate(template.id)" :key="template.id" class="pointer">
            <td>{{ template.id }}</td>
            <td>{{ template.name }}</td>
            <td>{{ template.subject }}</td>
            <td>{{ template.body }}</td>
          </tr>
          <tr v-if="templates && !templates.length">
            <td colspan="4" class="text-center">
              No results found
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <modal v-if="showModal" @close="closeModal" size="modal-large">
      <div slot="header">
        <h4>Follow up template</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Template name</label>
              <input v-model="template.name" class="form-control" type="text" @keydown="clearError($event)" />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col">
            <div class="select-wrap">
              <label>Email subject</label>
              <input v-model="template.subject" class="form-control" @keydown="clearError($event)" ref="subject"
                     @click="addingVariableOn = 'subject'"
              />
            </div>
            <error-field :errors="errors" field="subject" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap h-auto">
              <label>Email body</label>
              <textarea v-model="template.body" class="select-wrap-textarea form-control" cols="30" rows="10" ref="ta"
                        @click="addingVariableOn = 'ta'"
                        @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="body" />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <span class="badge badge-primary mx-1 unselectable pointer"
                  v-for="(variable, key, index) in variables" :key="index"
                  @dblclick="insertVariable(variable)"
            >{{ key }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button type="button" class="btn btn-delete float-left" @click="deleteFollowup" :disabled="!template.id">
              Delete
            </button>
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Cancel
            </button>
            <button type="button" class="btn btn-primary ld-ext-right"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
                    @click="save"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
        <div class="clearfix" />
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from '../../Modal';
import Errors from '../../../classes/Errors';
import ErrorField from '../../ErrorField';

export default {
  name: 'FollowUpTemplates',
  components: {
    Modal,
    ErrorField,
  },
  data: () => ({
    template: {
      name: '',
      subject: '',
      body: '',
    },
    templates: null,
    variables: [],
    showModal: false,
    addingVariableOn: 'subject',
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  mounted() {
    this.getEmailTemplates();
  },
  methods: {
    insertVariable(variable) {
      const textarea = this.addingVariableOn === 'subject' ? this.$refs.subject : this.$refs.ta;
      const cursorPosition = textarea.selectionStart;
      const textBefore = textarea.value.substring(0, cursorPosition);
      const textAfter = textarea.value.substring(cursorPosition, textarea.value.length);
      textarea.value = textBefore + variable + textAfter;
      if (this.addingVariableOn === 'subject') {
        this.template.subject = textarea.value;
      } else {
        this.template.body = textarea.value;
      }
      if (textarea.setSelectionRange) {
        textarea.focus();
        textarea.setSelectionRange(
          cursorPosition + variable.length,
          cursorPosition + variable.length,
        );
      }
    },
    getEmailTemplates() {
      axios
        .get('/lead-follow-up-email-templates')
        .then(res => {
          this.templates = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
      axios
        .get('/lead-follow-up-email-templates/variables')
        .then(res => {
          this.variables = res.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    editTemplate(id) {
      [this.template] = this.templates.filter(template => template.id === id);
      this.showModal = true;
    },
    save() {
      if (this.template.id) {
        this.buttonDisabled = true;
        this.loadingButton = true;
        axios
          .put(`/lead-follow-up-email-templates/${this.template.id}`, this.template)
          .then(() => {
            toastr.success('Template saved');
            this.showModal = false;
            this.getEmailTemplates();
            this.template = {
              name: '',
              subject: '',
              body: '',
            };
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      } else {
        this.buttonDisabled = true;
        this.loadingButton = true;
        axios
          .post('/lead-follow-up-email-templates', this.template)
          .then(res => {
            toastr.success('Template saved');
            this.showModal = false;
            this.templates.push(res.data.data);
            this.template = {
              name: '',
              subject: '',
              body: '',
            };
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    closeModal() {
      this.showModal = false;
      this.template = {};
    },
    deleteFollowup() {
      axios.delete(`/lead-follow-up-email-templates/${this.template.id}`).then(() => {
        toastr.success('Template successfully deleted');
        this.showModal = false;
        this.getEmailTemplates();
        this.template = {
          name: '',
          subject: '',
          body: '',
        };
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/Mailing/FollowUpTemplates.vue